// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill'
import store from './vuex/store'
import $ from 'jquery'
import axios from 'axios'



Vue.use(ElementUI)
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: 'ad4e189d262bda960487bc1e202bf9de',
    plugin: ['Autocomplete', 'PlaceSearch', 'Geocoder'],
    v: '1.4.4'
});

Vue.config.productionTip = false

//拦截器设置token
axios.interceptors.request.use(
    config => {
        if (localStorage.token) {
            if (config.method == 'get' || config.method == 'GET') {
                if (config.url.indexOf("?") != -1) {
                    config.url += "&r=" + Math.random();
                } else {
                    config.url += "?r=" + Math.random();
                }
            }
            config.headers.Authorization = localStorage.token;
        }
        return config
    }, error => {
        return Promise.reject(error)
    }
)

// axios.interceptors.response.use(
//   response => {
//     if(response.data.no == -6) {
//       //在其他终端登录，提示用户
//       localStorage.token = '';
//       alert('您的账号在别的地方登陆了')
//       router.push('/login')
//     }
//     return response
//   },error => {
//     if(error.response) {
//       //后台验证token失效返回401，跳转重新登录
//       if(error.response.status == 401) {
//         if(error.response.data.no == -6) {
//           localStorage.token = '';
//           alert('您的账号在别的地方登陆了')
//           router.push('/login')
//         }else {
//           localStorage.token = '';
//           alert('当前登录已过期，请重新登录');
//           router.push('/login')
//         }

//       }
//     }
//   }
// )

router.beforeEach((to, from, next) => {
        if (to.meta.auth) { //判断是否需要登录权限
            if (localStorage.token) {
                next();
            } else {
                next({
                    path: '/login',
                })
            }
        } else {
            next()
        }
    })
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js